import { useNavigate } from "react-router-dom";
import { Building2, FileCheck, Users, Check } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import { Button } from "@/components/ui/button";
import { TECH_URL } from "@/lib/api";

export default function Pro() {
  const navigate = useNavigate();
  return (
    <PublicLayout>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1D9BF0]">Entreprises & syndics</p>
            <h1 className="mt-2 text-4xl font-extrabold text-[#263871] sm:text-5xl">Climateasy pour les professionnels</h1>
            <p className="mt-4 text-lg text-slate-600">Gérez le parc de climatisation de tous vos sites depuis un seul compte. Contrats sur-mesure, facturation centralisée et suivi des interventions.</p>
            <div className="mt-8 space-y-3">
              {["Multi-sites et multi-équipements", "Contrats d'entretien adaptés à votre parc", "Reporting et preuves photo avant/après", "Interlocuteur unique"].map((t) => (
                <div key={t} className="flex gap-3 text-slate-700"><Check className="mt-0.5 h-5 w-5 shrink-0 text-emerald-500" />{t}</div>
              ))}
            </div>
            <Button data-testid="pro-cta" onClick={() => navigate("/rejoindre")} className="mt-8 h-12 rounded-full bg-[#263871] px-8 hover:bg-[#35508F]">Créer un compte pro</Button>
          </div>
          <div className="overflow-hidden rounded-3xl shadow-2xl shadow-blue-900/20">
            <img src={TECH_URL} alt="Maintenance professionnelle" className="h-[420px] w-full object-cover" />
          </div>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {[
            { icon: Building2, t: "Tous vos sites", d: "Centralisez bureaux, commerces et résidences." },
            { icon: FileCheck, t: "Conformité", d: "Traçabilité complète de chaque intervention." },
            { icon: Users, t: "Réseau certifié", d: "Des techniciens vérifiés partout en France." },
          ].map((c) => (
            <div key={c.t} className="rounded-2xl border border-slate-200 bg-white p-7">
              <div className="w-fit rounded-xl bg-[#E0F2FE] p-2.5"><c.icon className="h-6 w-6 text-[#1D9BF0]" /></div>
              <h3 className="mt-4 text-lg font-bold text-[#263871]">{c.t}</h3>
              <p className="mt-2 text-sm text-slate-600">{c.d}</p>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
